'use strict';

var config = require('widget/scripts/lib/config/main');

module.exports = {
    getReceiverFullUrl: getReceiverFullUrl,
    getReceiverDomain: getReceiverDomain
};

function getReceiverFullUrl(widgetId) {
    return [
        config.SERVICE_URL,
        config.RECEIVER_PATH,
        _getWidgetIdParamName()
    ].join('');

    function _getWidgetIdParamName() {
        return '?' + config.WIDGET_ID_PARAM_NAME + '=' + widgetId;
    }
}

function getReceiverDomain() {
    return config.SERVICE_URL;
}



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/receiverHelpers.js
// module id = 18
// module chunks = 0 1